module.exports = __webpack_public_path__ + "static/media/warn.b9b63837.wav";